import { S } from "../styles";

export function LoadingState({ label = "Loading…" }: { label?: string }) {
  return (
    <div style={S.card}>
      <p style={S.muted}>{label}</p>
    </div>
  );
}

export function ErrorState({ error }: { error: Error }) {
  return (
    <div style={S.card}>
      <p style={S.err}>⚠ {error.message}</p>
    </div>
  );
}

export function EmptyState({ message }: { message: string }) {
  return (
    <div style={S.card}>
      <p style={S.muted}>{message}</p>
    </div>
  );
}
